<app-header-app xLink="/login"></app-header-app>
<app-form-template
  heading="{{ 'PASSWORD_RESET.TITLE' | translate }}"
  [formGroup]="passwordForm"
  (submit)="setNewPassword()"
>
  <payee-password-form-field
    width="wide"
    formControlName="password"
  >
    <span payee-label>
      {{ "PASSWORD_RESET.PASSWORD_LABEL" | translate }}
    </span>
    @if (password.dirty) {
      <ng-container payee-error>
        @if (password.hasError("required")) {
          <mat-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
        @if (password.hasError("minlength")) {
          <mat-error>
            {{ "PASSWORD_RESET.PASSWORD_MINLENGTH" | translate }}
          </mat-error>
        }
      </ng-container>
    }
  </payee-password-form-field>

  <payee-password-form-field
    width="wide"
    formControlName="passwordConfirmation"
  >
    <span payee-label>
      {{ "PASSWORD_RESET.PASSWORD_CONFIRMATION_LABEL" | translate }}
    </span>
    @if (passwordConfirmation.dirty) {
      <ng-container payee-error>
        @if (passwordConfirmation.hasError("required")) {
          <mat-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </mat-error>
        }
        @if (passwordConfirmation.hasError("passwordsDontMatch")) {
          <mat-error>
            {{ "PASSWORD_RESET.PASSWORDS_DONT_MATCH" | translate }}
          </mat-error>
        }
      </ng-container>
    }
  </payee-password-form-field>

  <button
    payee-button
    width="wide"
    [disabled]="loading()"
  >
    @if (!loading()) {
      {{ "PASSWORD_RESET.SUBMIT_BUTTON" | translate }}
    }
    @if (loading()) {
      <div class="bw-theme flex hcenter">
        <mat-progress-spinner
          color="accent"
          mode="indeterminate"
          diameter="30"
        ></mat-progress-spinner>
      </div>
    }
  </button>
</app-form-template>
